import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGlobalContext } from '../../contexts/GlobalContext';

//Servicios
import { ViniedoService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import Vineyard from './Vineyard';
import { formatCoordinates } from '../../helpers';

function VineyardContainer() {
    const { token, user } = useGlobalContext();
    const Params = useParams();

    const [loader, setLoader] = useState(false);
    const [watchViniedoLogs, setWatchViniedoLogs] = useState(false);
    const [Coordinates, setCoordinates] = useState({});
    const [VineyardData, setVineyardData] = useState();

    //Formateador de coordenadas
    useEffect(() => {
        if (VineyardData) {
            formatCoordinates(
                VineyardData.features.features[0].geometry.x,
                VineyardData.features.features[0].geometry.y
            ).then((res) => {
                setCoordinates({
                    lat: res[0],
                    lon: res[1],
                });
            });
        }
    }, [VineyardData]);

    useEffect(() => {
        async function fetchVineyard() {
            try {
                setLoader(true);
                const arcGisVineyard = await ViniedoService.arcGisByNumber({
                    token,
                    viniedoId: parseInt(Params.id),
                });

                if (arcGisVineyard) {
                    setVineyardData(arcGisVineyard.data);
                }
                setLoader(false);
            } catch (err) {
                setLoader(false);
                console.log(err);
                return err;
            }
        }

        fetchVineyard();
    }, []);

    return loader ? (
        <Spinner />
    ) : (
        <Vineyard
            states={{ user, watchViniedoLogs, VineyardData, Coordinates }}
            functions={{ setWatchViniedoLogs }}
        />
    );
}

export default VineyardContainer;
